
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceindelhincr() {



    const cardData =
    {
        keyword: ' Corporate Cab Services in Delhi NCR  ',
        heading: 'etravo :  Corporate Cab Services in Delhi NCR',



"headingDescription": "eTravo provides reliable Corporate Cab Services in Delhi NCR for businesses, employees, executives, and corporate clients looking for safe, comfortable, and convenient transportation. From daily employee pickup and drop services and office commuting to airport transfers, business meetings, corporate events, and executive travel, eTravo offers flexible corporate cab services in Delhi NCR to meet diverse business transportation needs. With professional chauffeurs, well-maintained vehicles, and dependable service, eTravo helps businesses manage corporate and employee transportation efficiently across Delhi, Gurgaon, Noida, Ghaziabad, Faridabad, and other parts of the NCR region.",

"top": "Top Corporate Cab Service Zones in Delhi NCR with eTravo",

"topPlaces": [
  {
    "title": "Connaught Place (Delhi)",
    "description": "A central business district with corporate offices, banks, and commercial establishments requiring reliable executive and employee transport services."
  },
  {
    "title": "Cyber City (Gurgaon)",
    "description": "One of the largest corporate hubs in NCR with global companies and IT firms, demanding large-scale employee transportation solutions."
  },
  {
    "title": "Noida Sector 62 & 63",
    "description": "A major IT and business hub with corporate offices and tech parks requiring structured daily cab services."
  },
  {
    "title": "Udyog Vihar (Gurgaon)",
    "description": "A large industrial and corporate area with manufacturing units and offices needing daily pickup and drop services."
  },
  {
    "title": "Nehru Place (Delhi)",
    "description": "A prominent commercial and IT market with high employee movement requiring efficient corporate transport services."
  },
  {
    "title": "Aerocity (Delhi Airport Zone)",
    "description": "A premium business and hospitality hub near IGI Airport, ideal for corporate travel, client pickups, and executive transfers."
  },
  {
    "title": "Okhla Industrial Area (Delhi)",
    "description": "A major industrial and corporate zone with factories and offices requiring employee transport and logistics support."
  },
  {
    "title": "Greater Noida Industrial Hub",
    "description": "A growing corporate and manufacturing zone requiring workforce transportation and business travel services."
  },
  {
    "title": "MG Road & Golf Course Road (Gurgaon)",
    "description": "Premium commercial corridors with corporate offices and high demand for executive cab services."
  },
  {
    "title": "Dwarka & IGI Airport Corridor",
    "description": "A key travel route connecting residential and business zones to the airport, widely used for corporate travel and employee commute."
  }
],


"services": [
{
"name": "Corporate Cab Delhi NCR",
"description": "eTravo offers reliable corporate cab services in Delhi NCR designed for smooth and professional business travel. Our service ensures punctual pickups, comfortable rides, and experienced chauffeurs for daily office commuting and executive travel."
},
{
"name": "Corporate Taxi Delhi NCR",
"description": "Our corporate taxi services in Delhi NCR provide efficient and flexible transportation for businesses. eTravo ensures timely service, clean vehicles, and a seamless travel experience for executives and employees."
},
{
"name": "Company Cab Service Delhi NCR",
"description": "eTravo provides company cab services in Delhi NCR tailored for corporate needs. From employee transport to executive travel, our service ensures reliability, safety, and smooth operations."
},
{
"name": "Office Transport Delhi NCR",
"description": "Simplify daily commuting with eTravo’s office transport services in Delhi NCR. We offer structured and dependable transportation solutions for employees across all major business hubs."
},
{
"name": "Employee Cab Delhi NCR",
"description": "Our employee cab services in Delhi NCR are designed for safe and punctual workforce mobility. eTravo ensures well-planned routes and comfortable rides for daily commuting."
},
{
"name": "Corporate Travel Delhi NCR",
"description": "eTravo offers complete corporate travel services in Delhi NCR for both local and outstation needs. Our service ensures smooth and reliable travel for executives and business teams."
},
{
"name": "Business Cab Delhi NCR",
"description": "eTravo’s business cab services in Delhi NCR are ideal for meetings, client visits, and corporate activities. Our service focuses on punctuality, comfort, and professional travel experiences."
},
{
"name": "Staff Transport Delhi NCR",
"description": "eTravo provides dependable staff transport services in Delhi NCR for daily employee commuting. Our service ensures timely pickups, safe travel, and efficient coordination."
},
{
"name": "Corporate Fleet Delhi NCR",
"description": "eTravo offers corporate fleet services in Delhi NCR for businesses requiring multiple vehicles. Our fleet ensures consistent quality, proper maintenance, and smooth transportation operations."
},
{
"name": "Company Taxi Delhi NCR",
"description": "Our company taxi services in Delhi NCR provide flexible and convenient transport options for businesses. eTravo ensures reliable travel for employees, clients, and executives."
},
{
"name": "Corporate Pickup Drop Delhi NCR",
"description": "eTravo provides corporate pickup and drop services in Delhi NCR for efficient employee commuting. Our service ensures punctual scheduling and comfortable travel experiences."
},
{
"name": "Business Travel Cab Delhi NCR",
"description": "Our business travel cab services in Delhi NCR are designed for professionals traveling for meetings and corporate activities. eTravo ensures smooth, reliable, and comfortable journeys."
},
{
"name": "Office Cab Booking Delhi NCR",
"description": "eTravo offers easy office cab booking services in Delhi NCR with reliable and timely transportation. Our service ensures hassle-free travel for employees and corporate teams."
},
{
"name": "Corporate Commute Delhi NCR",
"description": "eTravo’s corporate commute services in Delhi NCR provide structured and efficient employee transportation. Our service ensures smooth daily travel with reliable vehicles and drivers."
},
{
"name": "Professional Cab Service Delhi NCR",
"description": "eTravo provides professional cab services in Delhi NCR designed to meet corporate standards. With trained drivers and well-maintained vehicles, we ensure safe, comfortable, and reliable travel."
}
],
"tableData": [
["Corporate Cab Delhi NCR", "Corporate Taxi Delhi NCR"],
["Company Cab Service Delhi NCR", "Office Transport Delhi NCR"],
["Employee Cab Delhi NCR", "Corporate Travel Delhi NCR"],
["Business Cab Delhi NCR", "Staff Transport Delhi NCR"],
["Corporate Fleet Delhi NCR", "Company Taxi Delhi NCR"],
["Corporate Pickup Drop Delhi NCR", "Business Travel Cab Delhi NCR"],
["Office Cab Booking Delhi NCR", "Corporate Commute Delhi NCR"],
["Professional Cab Service Delhi NCR", ""]
],




"whychoose": [
    {
      "WhyChooseheading": "Reliable Corporate Cab Services in Delhi NCR",
      "WhyChoosedescription": "eTravo offers dependable corporate cab services in Delhi NCR, ensuring smooth and efficient transportation for employees, executives, and business clients across Delhi, Gurgaon, Noida, and Ghaziabad."
    },
    {
      "WhyChooseheading": "End-to-End Corporate Travel Solutions",
      "WhyChoosedescription": "Corporate cab services in Delhi NCR include employee transport, airport transfers, executive travel, and long-term rentals, providing complete mobility solutions for businesses."
    },
    {
      "WhyChooseheading": "On-Time Employee Pickup and Drop",
      "WhyChoosedescription": "With structured schedules and optimized routes, employees reach offices on time, improving productivity and minimizing delays in daily operations."
    },
    {
      "WhyChooseheading": "Wide Fleet for Corporate Requirements",
      "WhyChoosedescription": "We provide hatchbacks, sedans, SUVs, and luxury vehicles suitable for daily office commute, executive travel, and VIP transportation."
    },
    {
      "WhyChooseheading": "Professional Chauffeurs with Corporate Etiquette",
      "WhyChoosedescription": "Our trained drivers ensure safe, punctual, and professional travel experience, maintaining high standards required for corporate clients."
    },
    {
      "WhyChooseheading": "Flexible Rental Plans for Businesses",
      "WhyChoosedescription": "eTravo offers hourly, daily, monthly, and long-term rental plans, allowing companies to customize transport solutions based on workforce needs."
    },
    {
      "WhyChooseheading": "Technology-Driven Fleet Management",
      "WhyChoosedescription": "GPS tracking, real-time monitoring, and route optimization ensure safety, transparency, and efficient employee transportation across NCR."
    },
    {
      "WhyChooseheading": "24/7 Support for Corporate Travel Needs",
      "WhyChoosedescription": "Our support team is available round the clock to handle bookings, changes, and emergency travel requirements for uninterrupted business operations."
    }
  ]

}

const faqData = [
    [
        {
            question: 'What are corporate cab services in Delhi NCR?',
            answer: 'Corporate cab services in Delhi NCR provide organized transportation for employees, executives, and clients including daily office commute and airport transfers.',
        },
        {
            question: 'Which areas are covered under Delhi NCR corporate cab services?',
            answer: 'Services cover Delhi, Gurgaon, Noida, Ghaziabad, and nearby regions within the National Capital Region.',
        },
        {
            question: 'Do corporate cab services provide daily pickup and drop?',
            answer: 'Yes, services include structured daily pickup and drop with fixed routes and schedules for employees.',
        },
        {
            question: 'Are corporate cab services available 24/7 in Delhi NCR?',
            answer: 'Yes, most providers operate round the clock to support business travel and shift-based operations.',
        },
        {
            question: 'What types of vehicles are available for corporate travel?',
            answer: 'Vehicles include hatchbacks, sedans, SUVs, and luxury cars depending on employee and executive travel needs.',
        },
        {
            question: 'Are corporate cab services safe for employees?',
            answer: 'Yes, services include GPS tracking, verified drivers, and safety protocols for secure travel.',
        },
        {
            question: 'Can corporate travel plans be customized?',
            answer: 'Yes, companies can customize routes, schedules, and rental plans based on their workforce requirements.',
        },
        {
            question: 'Do corporate cab services offer monthly contracts?',
            answer: 'Yes, companies can opt for monthly and long-term corporate transport contracts.',
        },
        {
            question: 'Are corporate cab services suitable for airport transfers?',
            answer: 'Yes, they provide seamless airport pickup and drop services for employees and corporate clients.',
        },
        {
            question: 'How can I book corporate cab services in Delhi NCR?',
            answer: 'You can book through the service provider’s website or contact their support team for customized corporate travel solutions.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Amit Khanna',
        designation: 'Operations Manager, Corporate Firm, Delhi NCR',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo provides excellent corporate cab services across Delhi NCR. Their punctual service and professional drivers ensure smooth daily operations.”',
    },
    {
        name: 'Ms. Neha Arora',
        designation: 'HR Manager, IT Company, Gurgaon',
        rating: [1, 1, 1, 1, 1],
        text: '“We rely on eTravo for employee transportation in NCR. Their flexible plans and reliable service make commuting easy for our team.”',
    },
];




    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];










// const productSchema = {
//   "@context": "https://schema.org",
//   "@type": "Product",
//   "name": "Corporate Cab Services in Delhi NCR",
//   "image": "https://www.etravo.in/images/keyword/corporate-cab-delhi-ncr.jpg",
//   "description": "Reliable corporate cab services in Delhi NCR by eTravo. Ideal for employee transport, office pickup and drop, business travel, corporate commute, and professional fleet solutions with safe and efficient service.",
//   "brand": {
//     "@type": "Brand",
//     "name": "eTravo"
//   },
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "bestRating": "5",
//     "worstRating": "1",
//     "ratingValue": "4.7",
//     "ratingCount": "1250"
//   },
//   "offers": {
//     "@type": "Offer",
//     "priceCurrency": "INR",
//     "price": "2199",
//     "availability": "https://schema.org/InStock",
//     "url": "https://www.etravo.in/corporate-cab-services-in-delhi-ncr"
//   }
// };
const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Corporate Cab Services in Delhi NCR",
  "serviceType": "Corporate Cab Services",
  "description":
    "Professional corporate cab services in Delhi NCR for employee transportation, office commuting, business travel, airport transfers, executive travel, and corporate transportation requirements.",
  "provider": {
    "@type": "Organization",
    "name": "eTravo",
    "url": "https://www.etravo.in/"
  },
  "areaServed": [
    {
      "@type": "Place",
      "name": "Delhi NCR"
    },
    {
      "@type": "City",
      "name": "Delhi"
    },
    {
      "@type": "City",
      "name": "Gurugram"
    },
    {
      "@type": "City",
      "name": "Noida"
    },
    {
      "@type": "City",
      "name": "Ghaziabad"
    },
    {
      "@type": "City",
      "name": "Faridabad"
    }
  ],
  "url": "https://www.etravo.in/corporate-cab-services-in-delhi-ncr"
};






    return (
        <div>

            <Helmet>
  {/* Primary SEO */}
  <title>
    Corporate Cab Services in Delhi NCR | Employee Transport | eTravo
  </title>

  <meta
    name="description"
    content="Book corporate cab services in Delhi NCR with eTravo for employee transportation, office commuting, business travel, airport transfers and executive transportation."
  />

  <meta
    name="keywords"
    content="corporate cab services in Delhi NCR, corporate cab service Delhi NCR, corporate transportation Delhi NCR, employee transportation Delhi NCR, office cab services Delhi NCR, corporate cab Delhi, corporate cab Gurgaon, corporate cab Noida"
  />

  {/* Canonical */}
  <link
    rel="canonical"
    href="https://www.etravo.in/corporate-cab-services-in-delhi-ncr"
  />

  {/* Robots */}
  <meta
    name="robots"
    content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
  />

  {/* Open Graph */}
  <meta
    property="og:title"
    content="Corporate Cab Services in Delhi NCR | Employee Transport | eTravo"
  />

  <meta
    property="og:description"
    content="Reliable corporate cab services in Delhi NCR for employee transportation, office travel, business trips, airport transfers and executive transportation."
  />

  <meta
    property="og:type"
    content="website"
  />

  <meta
    property="og:url"
    content="https://www.etravo.in/corporate-cab-services-in-delhi-ncr"
  />

  <meta
    property="og:image"
    content="https://www.etravo.in/images/keyword/corporate-cab-services-in-delhi-ncr.jpg"
  />

  <meta
    property="og:image:alt"
    content="Corporate cab services in Delhi NCR"
  />

  {/* Twitter */}
  <meta
    name="twitter:card"
    content="summary_large_image"
  />

  <meta
    name="twitter:title"
    content="Corporate Cab Services in Delhi NCR | eTravo"
  />

  <meta
    name="twitter:description"
    content="Corporate cab and employee transportation services across Delhi NCR for offices, businesses, executives, airport transfers and corporate travel."
  />

  <meta
    name="twitter:image"
    content="https://www.etravo.in/images/keyword/corporate-cab-services-in-delhi-ncr.jpg"
  />

  {/* Structured Data */}
  <script type="application/ld+json">
    {JSON.stringify(serviceSchema)}
  </script>
</Helmet>
{/* <Helmet>
  <title>Corporate Cab Services in Delhi NCR | Office & Employee Transport | eTravo</title>
  <meta 
    name="description" 
    content="Book corporate cab services in Delhi NCR with eTravo for employee transport, office pickup and drop, business travel, and corporate commute solutions. Reliable and professional service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet> */}



            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/corporate-cab-services-in-delhi-ncr.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceindelhincr;